"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-spring-manufacturing";
const IMAGE_BASE = "/image/new-version/more/SpringManufacturing/Quality";

const IMAGES = [
	{ src: `${IMAGE_BASE}/spring-manufacturing-with-guaranteed-quality-1.webp`, altKey: "qualityImageAlt1" },
	{ src: `${IMAGE_BASE}/spring-manufacturing-with-guaranteed-quality-2.webp`, altKey: "qualityImageAlt2" },
	{ src: `${IMAGE_BASE}/spring-manufacturing-with-guaranteed-quality-3.webp`, altKey: "qualityImageAlt3" },
	{ src: `${IMAGE_BASE}/spring-manufacturing-with-guaranteed-quality-4.webp`, altKey: "qualityImageAlt4" },
] as const;

const FEATURES = ["qualityFeature1", "qualityFeature2", "qualityFeature3", "qualityFeature4"] as const;

export default function SpringManufacturingQuality() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("qualityTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("qualityDesc")}</p>
				</header>

				<div className="grid items-center gap-8 lg:grid-cols-[5fr_6fr] lg:gap-12">
					<div className="grid grid-cols-2 gap-4">
						{IMAGES.map((image) => (
							<div key={image.altKey} className="relative aspect-[4/4] overflow-hidden bg-white">
								<Image
									src={image.src}
									alt={t(image.altKey)}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 50vw, 25vw"
								/>
							</div>
						))}
					</div>

					<div className="flex flex-col gap-5 sm:gap-6 md:gap-7">
						{FEATURES.map((feature) => (
							<div key={feature}>
								<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:mb-3 sm:text-lg md:text-xl">
									{t(`${feature}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${feature}Desc`)}</p>
							</div>
						))}
						<Link
							href="/quality-assurance"
							className="inline-flex w-fit items-center gap-1 text-sm font-bold text-themePrimary400 transition-colors hover:text-[#83b751] md:text-base"
						>
							{t("qualityLearnMore")}
							<svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M7 17L17 7M17 7H9M17 7v8"
								/>
							</svg>
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
}
